<footer class="{{footerClass}}">
    <div class="container">
        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <a routerLink="/" class="logo"><img src="assets/img/devotorylogo.png" style="width: 200px !important;" alt="Devotory"></a>
                    <p>Transforming businesses with innovative solutions and expert services. Partner with us for unparalleled IT excellence</p>
                    <ul class="social-link">
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li>
                        <!-- <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-twitter'></i></a></li>
                        <li><a href="#" class="d-block" target="_blank"><i class='bx bxl-instagram'></i></a></li> -->
                        <li><a href="https://www.linkedin.com/company/devotory-solutions/?lipi=urn%3Ali%3Apage%3Ad_flagship3_company_admin%3BqYmMl1o6SD%2BLfU95HzF22A%3D%3D" class="d-block" target="_blank"><i class='bx bxl-linkedin'></i></a></li>
                    </ul>
                </div>
            </div>

            <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget pl-5">
                    <h3>Explore</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="">Home</a></li>
                        <li><a routerLink="/about-us">About</a></li>
                        <!-- <li><a routerLink="/case-studies-3-columns">Case Studies</a></li>
                        <li><a routerLink="/blog">Our Blog</a></li> -->
                        <li><a routerLink="/contact">Contact</a></li>
                    </ul>
                </div>
            </div>

            <!-- <div class="col-lg-2 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Resources</h3>
                    <ul class="footer-links-list">
                        <li><a routerLink="/team">Our Scientists</a></li>
                        <li><a routerLink="/services">Our Services</a></li>
                        <li><a routerLink="/">Testimonials</a></li>
                        <li><a routerLink="/services-details">SaaS Solutions</a></li>
                        <li><a routerLink="/services-details">eCommerce</a></li>
                    </ul>
                </div>
            </div> -->

            <div class="col-lg-4 col-md-6 col-sm-6">
                <div class="single-footer-widget">
                    <h3>Address</h3>
                    <ul class="footer-contact-info">
                        <li><i class='bx bx-map'></i>30 N Gould Street, Sheridan, Wyoming 82801</li>
                        <li><i class='bx bx-phone-call'></i><a href="tel:+12095001603">+1 (209) 500 1603</a></li>
                        <li><i class='bx bx-envelope'></i><a href="mailto:info@devotory.com">info&#64;devotory.com</a></li>
                        <!-- <li><i class='bx bxs-inbox'></i><a href="tel:+557854578964">+55 785 4578964</a></li> -->
                    </ul>
                </div>
            </div>
        </div>

        <div class="footer-bottom-area">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-6">
                    <p>©2024 devotory llc. All rights reserved 
                        <!-- <a href="https://envytheme.com/" target="_blank">EnvyTheme</a> -->
                    </p>
                </div>

                <!-- <div class="col-lg-6 col-md-6">
                    <ul>
                        <li><a routerLink="/">Privacy Policy</a></li>
                        <li><a routerLink="/">Terms & Conditions</a></li>
                    </ul>
                </div> -->
            </div>
        </div>
    </div>

    <div class="footer-map"><img src="assets/img/footer-map.png" alt="image"></div>
</footer>

<div class="go-top"><i class="flaticon-up"></i></div>